// extracted by mini-css-extract-plugin
export default {"iconRect":"iconRect-vMbIG"};